export default __webpack_public_path__ + "static/media/location-black.7894e86c.svg";